import React, { useEffect } from "react";
import { NoLocationSelectedProps } from "./types";
import Button from "../Button";
import i18next from "i18next";
import useTriggerAddressPopupListener from "../../Helpers/hooks/useTriggerAddressPopupListener";

export const NoLocation = ({
    initialized,
    setOverlayOpen,
    setForceOverlay,
}) => {
    const { noPopupPaths } = reactConfig;

    useEffect(() => {
        if (!initialized || !noPopupPaths) return;

        // don't show if start page
        if (window.location.pathname === "/") return;

        // don't show if url is in no popup path
        if (
            noPopupPaths.filter(
                (item) => window.location.pathname.indexOf(item) === 0
            ).length
        )
            return;

        const ProductDetailPage = new RegExp(
            `^/bestellen/(salate|bowls|getraenke|brote|desserts)/([^\\s]+)/$`
        );

        // dont't show on product details page
        if (ProductDetailPage.test(window.location.pathname)) {
            return;
        }

        setOverlayOpen(true);
    }, [initialized]);

    useTriggerAddressPopupListener(({ detail }) => {
        setForceOverlay(detail);
        setOverlayOpen(true);
    });

    return (
        <div className="select-location">
            <strong className="select-location__address">
                {i18next.t("topbar.label.question")}
            </strong>
            <Button
                customStyle="select-location__button"
                label={i18next.t("topbar.label.change")}
                onClick={() => setOverlayOpen(true)}
                variant="secondary"
                size="XS"
            />
        </div>
    );
};

NoLocation.propTypes = NoLocationSelectedProps;
